import type { ClassValue } from 'clsx';

import {
  GlossaryIndex,
  GlossaryIndexColumns,
  GlossaryIndexCount,
  GlossaryIndexTerm,
  GlossaryIndexTermItem,
} from '@vs-shop/commerce-ui/glossaryIndex';
import { clsxm } from '@vs-shop/utils';

import { getMemoizedIntlShapeWithDefaultLocale } from '../../../../utils/intl';

import type { GlossaryTermIndex } from '@vs-shop/schemas/branded/MiscSchema';

type Props = {
  terms: readonly GlossaryTermIndex[];
  className?: ClassValue;
};

export function GlossaryFavoritesGrid({ terms, className }: Props) {
  const intl = getMemoizedIntlShapeWithDefaultLocale();

  return (
    <GlossaryIndex data-mode="favorites" className={clsxm(className)}>
      <GlossaryIndexCount>
        {intl.formatMessage({
          id: 'component.client.page.glossary.favorites.heading',
          defaultMessage: 'Oblíbené pojmy ze slovníku',
        })}
      </GlossaryIndexCount>

      <GlossaryIndexColumns render={<ul />}>
        {terms.map((term) => (
          <GlossaryIndexTermItem key={term.code}>
            <GlossaryIndexTerm href={term.routerUrl}>{term.name ?? ''}</GlossaryIndexTerm>
          </GlossaryIndexTermItem>
        ))}
      </GlossaryIndexColumns>
    </GlossaryIndex>
  );
}
